// extracted by mini-css-extract-plugin
export default {"modalBodyWrapper":"modal_modalBodyWrapper__SWvvG","modalFullScreen":"modal_modalFullScreen__+8z70"};